"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/OnboardingSteps/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');
var _hooks = require('web/services/hooks');

var _user = require('shared/selectors/user');




var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _types = require('web/screens/Signup/types');
var _components = require('web/screens/Signup/components');




var _onboardingShared = require('web/screens/onboardingShared');
var _ReadyToGo = require('web/screens/Signup/Setup/Sections/ReadyToGo'); var _ReadyToGo2 = _interopRequireDefault(_ReadyToGo);
var _readyToGoNotice = require('web/screens/onboardingShared/readyToGoNotice');

const FINISH_STEP_META = _onboardingAnalytics.ONBOARDING_STEP_META[_types.SetupSteps.FINISH]

// sessionStorage-backed one-shot guard so a reload never re-emits a funnel event
// for the same org/step. Keyed by org only (the free path has no checkout attempt).
const emitOnce = (key, emit) => {
  try {
    if (sessionStorage.getItem(key)) return
    sessionStorage.setItem(key, '1')
  } catch (e) {
    // best-effort; storage may be unavailable in private modes
  }
  emit()
}

/**
 * Final authenticated confirmation (`/onboarding-steps?org=`), shared by the
 * free, skipped, checkout-failure, and successful-checkout paths.
 */
const OnboardingSteps = () => {
  const { orgParam, currentUser, isValidOrg } = _onboardingShared.useOnboardingOrgGate.call(void 0, )
  const onFinishToInbox = _onboardingShared.useOnboardingFinishToInbox.call(void 0, )
  const [notice] = _react.useState.call(void 0, () =>
    orgParam ? _readyToGoNotice.consumeTrialStartFailedNotice.call(void 0, orgParam) : undefined)

  const guardKey = (kind) => `onb_steps_${orgParam}_${kind}`
  const onComplete = _react.useCallback.call(void 0, () => {
    emitOnce(guardKey('finish_completed'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED, {
        ...FINISH_STEP_META, organization_id: orgParam,
      }))
    return onFinishToInbox()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, onFinishToInbox])

  // The final step is viewed once the authenticated org is verified.
  _react.useEffect.call(void 0, () => {
    if (!isValidOrg || !orgParam || !currentUser) return
    emitOnce(guardKey('finish'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_VIEWED, {
        ...FINISH_STEP_META, organization_id: orgParam,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidOrg, orgParam, currentUser])

  // Wait for auth bootstrap; the gate redirects a foreign org.
  if (!currentUser || !isValidOrg) {
    return _react2.default.createElement(_onboardingShared.OnboardingLayout, { size: "sm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}} ))
  }

  return (
    _react2.default.createElement(_onboardingShared.OnboardingLayout, { size: "sm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
      , _react2.default.createElement(_ReadyToGo2.default, { onComplete: onComplete, notice: notice, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}} )
    )
  )
}

// Keyed by org so org-scoped state never survives an ?org= switch on the same
// route (same rationale as OnboardingPayment's wrapper).
const OnboardingStepsByOrg = () => {
  const { search } = _reactrouterdom.useLocation.call(void 0, )
  const orgKey = new URLSearchParams(search).get('org') || ''
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)
  return _react2.default.createElement(OnboardingSteps, { key: `${orgKey}:${_optionalChain([currentUser, 'optionalAccess', _ => _.UserKey]) || ''}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}} )
}

exports. default = OnboardingStepsByOrg
